import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Krachttraining tijdens de zwangerschap: veilig en effectief
                </title>
                <link rel="canonical" href={route("blogs.seventy-four")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Zwangerschap is een bijzondere periode in het leven van een vrouw, waarin haar lichaam ingrijpende veranderingen ondergaat. Veel zwangere vrouwen vragen zich af of ze kunnen blijven sporten en of krachttraining veilig is. Goed nieuws: met de juiste aanpak kan krachttraining tijdens de zwangerschap niet alleen veilig zijn, maar ook vele voordelen bieden. In dit artikel bespreken we, gebaseerd op wetenschappelijk onderzoek, welke oefeningen geschikt zijn per trimester en waar je op moet letten."
                />
                <meta
                    property="og:description"
                    content="Zwangerschap is een bijzondere periode in het leven van een vrouw, waarin haar lichaam ingrijpende veranderingen ondergaat. Veel zwangere vrouwen vragen zich af of ze kunnen blijven sporten en of krachttraining veilig is. Goed nieuws: met de juiste aanpak kan krachttraining tijdens de zwangerschap niet alleen veilig zijn, maar ook vele voordelen bieden. In dit artikel bespreken we, gebaseerd op wetenschappelijk onderzoek, welke oefeningen geschikt zijn per trimester en waar je op moet letten."
                />
                <meta property="og:url" content={route("blogs.seventy-four")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Krachttraining tijdens de zwangerschap: veilig en effectief - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/zwanger.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/zwanger.webp"
                                    type="image/webp"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/zwanger.jpg"
                                    type="image/png"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/zwanger.jpg"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Krachttraining tijdens de zwangerschap: veilig en
                        effectief
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Zwangerschap is een bijzondere periode in het leven van
                        een vrouw, waarin haar lichaam ingrijpende veranderingen
                        ondergaat. Veel zwangere vrouwen vragen zich af of ze
                        kunnen blijven sporten en of krachttraining veilig is.
                        Goed nieuws: met de juiste aanpak kan krachttraining
                        tijdens de zwangerschap niet alleen veilig zijn, maar
                        ook vele voordelen bieden. In dit artikel bespreken we,
                        gebaseerd op wetenschappelijk onderzoek, welke
                        oefeningen geschikt zijn per trimester en waar je op
                        moet letten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De voordelen van krachttraining tijdens de zwangerschap
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voordat we ingaan op specifieke oefeningen, is het
                        belangrijk om de voordelen van{" "}
                        <a
                            href={route("blogs.sixty-five")}
                            className="text-we-are-yellow"
                        >
                            krachttraining
                        </a>{" "}
                        tijdens de zwangerschap te begrijpen:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            Verbeterde spierkracht en uithoudingsvermogen
                        </li>
                        <li className="mt-2">
                            Verminderde rugpijn en andere
                            zwangerschapsgerelateerde ongemakken
                        </li>
                        <li className="mt-2">Betere houding en balans</li>
                        <li className="mt-2">
                            Verhoogde energie en verbeterde stemming
                        </li>
                        <li className="mt-2">
                            Sneller herstel na de bevalling
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoek heeft aangetoond dat regelmatige
                        lichaamsbeweging, waaronder krachttraining, veilig is
                        voor de meeste zwangere vrouwen en zelfs wordt
                        aanbevolen (American College of Obstetricians and
                        Gynecologists, 2020).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Algemene richtlijnen voor krachttraining tijdens de
                        zwangerschap
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voordat je begint met een trainingsprogramma, is het
                        essentieel om eerst met je verloskundige of gynaecoloog
                        te overleggen. Zij kunnen je adviseren op basis van je
                        persoonlijke gezondheidssituatie. Houd daarnaast de
                        volgende algemene richtlijnen in gedachten:
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Begin langzaam en bouw geleidelijk op
                        </li>
                        <li className="mt-2">
                            Luister naar je lichaam en stop bij ongemak of pijn
                        </li>
                        <li className="mt-2">Blijf goed gehydrateerd</li>
                        <li className="mt-2">
                            Vermijd oefeningen waarbij je op je rug ligt na het
                            eerste trimester
                        </li>
                        <li className="mt-2">
                            Pas op voor overbelasting van de bekkenbodem
                        </li>
                        <li className="mt-2">
                            Vermijd contactsporten en activiteiten met valrisico
                        </li>
                    </ul>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Krachttraining per trimester
                    </h2>
                    <h3 className="text-white mt-4 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Eerste trimester (week 1-13)
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens het eerste trimester kun je vaak je normale
                        trainingsroutine voortzetten, met enkele aanpassingen:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            <strong>Squats</strong>: Helpen bij het versterken
                            van de beenspieren en core. <i>Tip</i>: Houd je rug
                            recht en ga niet dieper dan 90 graden.
                        </li>
                        <li className="mt-2">
                            <strong>Push-ups</strong>: Versterk borst-,
                            schouder- en armspieren. <i>Tip</i>: Doe ze op je
                            knieën als de volledige versie te zwaar wordt.
                        </li>
                        <li className="mt-2">
                            <strong>Lunges</strong>: Verbeteren balans en
                            beensterkte. <i>Tip</i>: Houd je bewegingen
                            gecontroleerd en gebruik eventueel steun.
                        </li>
                        <li className="mt-2">
                            <strong>Planken</strong>: Versterken de core en
                            rugspieren. <i>Tip</i>: Begin met korte intervallen
                            en bouw op naarmate je sterker wordt.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoek toont aan dat krachttraining in het eerste
                        trimester veilig is en zelfs kan helpen bij het
                        verminderen van zwangerschapsgerelateerde klachten
                        (Barakat et al., 2015).
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Tweede trimester (week 14-26)
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        In het tweede trimester groeit je buik en verandert je
                        zwaartepunt. Pas je oefeningen hierop aan:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            <strong>Kabelroeien</strong>: Versterkt de rug en
                            helpt bij het behouden van een goede houding.{" "}
                            <i>Tip</i>: Gebruik een lichte tot matige weerstand.
                        </li>
                        <li className="mt-2">
                            <strong>Goblet squats</strong>: Een veilige variant
                            van squats met extra ondersteuning. <i>Tip</i>: Houd
                            een kettlebell of dumbell vast tegen je borst.
                        </li>
                        <li className="mt-2">
                            <strong>Staande bicep curls</strong>: Versterken de
                            armen zonder druk op de buik. <i>Tip</i>: Gebruik
                            lichtere gewichten dan je gewend bent.
                        </li>
                        <li className="mt-2">
                            <strong>Zijwaartse leg raises</strong>: Versterken
                            de heup- en bilspieren. <i>Tip</i>: Houd je core
                            aangespannen tijdens de oefening.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Studies tonen aan dat krachttraining in het tweede
                        trimester kan helpen bij het behouden van een gezond
                        gewicht en het verminderen van rugpijn (Petrov Fieril et
                        al., 2015).
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Derde trimester (week 27-bevalling)
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        In het laatste trimester ligt de focus op het behouden
                        van kracht en mobiliteit:
                    </p>

                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            <strong>Wandelende lunges</strong>: Verbeteren
                            balans en beensterkte. <i>Tip</i>: Neem kleinere
                            stappen dan normaal voor meer stabiliteit.
                        </li>
                        <li className="mt-2">
                            <strong>Seated rows</strong>: Versterken de rug
                            zonder druk op de buik. <i>Tip</i>: Gebruik een
                            weerstandsband of kabelmachine.
                        </li>
                        <li className="mt-2">
                            <strong>Kneeling push-ups</strong>: Een aangepaste
                            versie van push-ups. <i>Tip</i>: Plaats je handen op
                            een verhoogd oppervlak voor meer comfort.
                        </li>
                        <li className="mt-2">
                            <strong>Bekkenbodemtraining</strong>: Essentieel
                            voor een goede bevalling en herstel. <i>Tip</i>:
                            Oefen regelmatig gedurende de dag.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoek wijst uit dat krachttraining tot aan het einde
                        van de zwangerschap veilig kan zijn en zelfs kan
                        bijdragen aan een vlottere bevalling (Bø et al., 2016).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waar moet je op letten?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij het uitvoeren van krachttraining tijdens de
                        zwangerschap is het belangrijk om alert te zijn op de
                        volgende punten:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            <strong>Overbelasting</strong>: Vermijd zware
                            gewichten en hoge intensiteit. Focus op controle en
                            goede vorm.
                        </li>
                        <li className="mt-2">
                            <strong>Bekkeninstabiliteit</strong>: Stop met
                            oefeningen die pijn of ongemak in het bekkengebied
                            veroorzaken.
                        </li>
                        <li className="mt-2">
                            <strong>Ademhaling</strong>: Adem regelmatig en
                            vermijd het vasthouden van je adem tijdens
                            oefeningen.
                        </li>
                        <li className="mt-2">
                            <strong>Bloedsuikerspiegel</strong>: Eet voldoende
                            voor en na je training om een stabiele{" "}
                            <a
                                href={route("blogs.forty-five")}
                                className="text-we-are-yellow"
                            >
                                bloedsuikerspiegel
                            </a>{" "}
                            te behouden.
                        </li>
                        <li className="mt-2">
                            <strong>Lichaamstemperatuur</strong>: Voorkom
                            oververhitting door voldoende te drinken en niet te
                            intensief te trainen.
                        </li>
                        <li className="mt-2">
                            <strong>Ligamentlaxiteit</strong>: Wees voorzichtig
                            met stretchen, aangezien je ligamenten soepeler zijn
                            tijdens de zwangerschap.
                        </li>
                    </ol>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Krachttraining kan een waardevolle aanvulling zijn op je
                        zwangerschapsroutine, mits je de juiste
                        voorzorgsmaatregelen neemt en luistert naar je lichaam.
                        Door je oefeningen aan te passen aan elk trimester, kun
                        je veilig en effectief blijven trainen. Niet alleen help
                        je hiermee je lichaam voor te bereiden op de bevalling,
                        maar je legt ook een sterke basis voor een sneller
                        herstel na de geboorte van je baby.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        American College of Obstetricians and Gynecologists.
                        (2020). Physical activity and exercise during pregnancy
                        and the postpartum period. Obstetrics & Gynecology,
                        135(4), e178-e188.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Barakat, R., Perales, M., Garatachea, N., Ruiz, J. R., &
                        Lucia, A. (2015). Exercise during pregnancy. A narrative
                        review asking: What do we know? British Journal of
                        Sports Medicine, 49(21), 1377-1381.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bø, K., Artal, R., Barakat, R., Brown, W., Davies, G.
                        A., Dooley, M., ... & Khan, K. M. (2016). Exercise and
                        pregnancy in recreational and elite athletes: 2016
                        evidence summary from the IOC expert group meeting,
                        Lausanne. Part 1—exercise in women planning pregnancy
                        and those who are pregnant. British Journal of Sports
                        Medicine, 50(10), 571-589.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Petrov Fieril, K., Glantz, A., Fagevik Olsén, M., &
                        Kjellby-Wendt, G. (2015). The efficacy of moderate
                        -to-vigorous resistance exercise during pregnancy: a
                        randomized controlled trial. Acta Obstetricia et
                        Gynecologica Scandinavica, 94(1), 35-42.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
